var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-card__brand",class:{ 'member-card__brand--default': _vm.isDefault },style:(("background-image:url(" + (require(("@/assets/images/icons/payments/icon-" + _vm.iconFileName + ".svg"))) + ")"))})}
var staticRenderFns = []

export { render, staticRenderFns }